<template>
  <!-- Modal -->
  <div>
    <div class="modal" name="token-popup" id="Token-popup" transition="pop-out" :width="800" :adaptive="true" :maxWidth="800" height="600" :scrollable="true">
      <div class="modal-content" v-if="step == 1">
        <div class="modal-head">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="yes-sec">
            <h2>Purchase Impact Tokens</h2>
            <section>
              <div class="loading" v-if="optionLoader">
                <div class="load">
                  <hr><hr><hr><hr>
                  <div class="loadback"></div>
                </div>
              </div>
              <!-- user store monthly or auto top up setting  -->
              <div class="form-row token-puchase-row row" v-if="!this.onlyEditSettings && isUserCardAdded && !optionLoader">
                <div class="col-md-6">
                  <p>Your Token balance (USD): <b>{{companySettings.total_outstanding ? commafy(companySettings.total_outstanding) : '0.00'}} ({{companySettings.unallocated ? commafy(companySettings.unallocated) : 0}} available)</b></p>
                  <label>Top-up amount (USD)</label>
                  <input type="text" name="token-amount" id="token-amount" v-model="tokenamt" placeholder="100" v-on:keyup="checkNumbersOnly('token-amount')" style="width: 100px">
                  <p class="small" style="font-size: 14px; margin-top: 15px;" v-if="surcharge > 0">Please note that {{surcharge}}% surcharge applies to fund the extra admin, data management and development of engagement tools. Your support helps B1G1’s work to ensure effective impact creation.</p>
                  <p class="small" style="font-size: 14px; margin-top: 15px;">By proceeding, you agree to <a href="https://www.b1g1.org/b1g1-giving-terms-of-service#impact-tokens" target="_blank">B1G1 Giving’s Terms and Conditions</a>.</p>
                  <p v-if="isCharityCountry!=false" class="small" style="font-size: 14px; margin-top: 15px;"><a href="https://www.b1g1.org/charity-disclosure" style="font-weight: 500; align:center;" target="_blank">Charity Disclosure</a></p>

                </div>
                <div class="col-md-6" style="padding-left: 50px;">
                  <aside>
                    <label>
                      <input type="radio" name="rd_billing_period" value="one-time" id="rd-beginning-billing-period" v-model="billing_period">
                      One-time purchase</label>
                    <br>
                    <label>
                      <input type="radio" name="rd_billing_period" value="monthly" id="rd-beginning-billing-period" v-model="billing_period" >
                      Top up this amount every month</label>
                    <br>
                    <div class="sub-options" v-if="billing_period === 'monthly'">
                      <label>
                        <input type="radio" name="monthly_billing_period" value="beginning" id="rd-beginning-billing-period" v-model="monthly_billing_period">
                        Beginning of the month</label>
                      <br>
                      <label>
                        <input type="radio" name="monthly_billing_period" value="middle" id="rd-middle-billing-period " v-model="monthly_billing_period">
                        Middle of the month</label>
                      <br>
                      <label>
                        <input type="radio" name="monthly_billing_period" value="end" id="rd-end-billing-period" v-model="monthly_billing_period">
                        End of the month</label>
                      <br>
                    </div>
                    <label>
                      <input type="radio" name="rd_billing_period" value="topup" id="token-topup-option" v-model="billing_period">
                      Auto top-up at (USD)  <span v-tooltip.top="{ content: 'Your Token balance will automatically top up when it drops to this amount.', class: 'normal-tooltip' }" class="fa fa-info-circle fa-lg infopop" data-container="body" data-toggle="popover"></span></label>
                      <input type="text" name="topup-token-amount" id="topup-token-amount" v-model="topupamt" placeholder="20" min="1" max="1000" v-on:keyup="checkNumbersOnly('topup-token-amount')" style="width: 60px">
                    <br>
                  </aside>
                  <button class="b-btn red-btn" @click="showConfirmationModal()">PROCEED</button>
                </div>
              </div>
              <!-- When one time purchase setting on -->
              <div v-else-if="!optionLoader">
                <div class="form-row token-puchase-row row">
                  <div class="col-md-6">
                    <p>Your Token balance (USD): <b>{{companySettings.total_outstanding ? commafy(companySettings.total_outstanding) : '0.00'}} ({{companySettings.unallocated ? commafy(companySettings.unallocated) : 0}} available)</b></p>
                  </div>
                  <div class="col-md-6" style="padding-left: 50px;">
                    <aside>Top-up amount (USD)
                      <input type="text" name="token-amount" id="token-amount" v-model="tokenamt" placeholder="100" v-on:keyup="checkNumbersOnly('token-amount')" style="width: 100px">
                     </aside>
                  </div>
                  <div class="col-md-11">
                    <br>
                    <p style="font-size: 16px;" v-if="surcharge > 0">Please note that {{surcharge}}% surcharge applies to fund the extra admin, data management and development of engagement tools. Your support helps B1G1’s work to ensure effective impact creation.</p>
                    <p style="font-size: 16px;">By proceeding, you agree to <a href="https://www.b1g1.org/b1g1-giving-terms-of-service#impact-tokens" target="_blank">B1G1 Giving’s Terms and Conditions.</a></p>
                  </div>
                  <div class="col-md-6"></div>
                  <div class="col-md-6 text-center">
                    <button class="b-btn red-btn" @click="showConfirmationModal()" style="">Purchase Impact Tokens</button><br>
                    <a href="/billing-tokens" style="font-size: 16px;" v-if="this.onlyEditSettings">Or update your automatic Token top-up setting</a>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      <div class="modal-content" v-if="step == 2">
        <div class="modal-head">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <!-- process to payment confirmation popup -->
          <div class="billing-popup">
            <h2 v-if="billing_period === 'one-time'">Purchase Impact Tokens</h2>
            <h2 v-else>Setting up Impact Token billing</h2>

            <p v-if="billing_period === 'one-time'">You are about to purchase <b>US ${{tokenamt|currency}}</b> worth of Impact Tokens.</p>

            <p v-if="billing_period === 'monthly'">You are about to set up an auto monthly top-up of <br><b>US ${{tokenamt|currency}} worth of Impact Tokens.</b> You will be billed in the {{monthly_billing_period}} of the month.</p>

            <span v-if="billing_period === 'topup'">
              <p>You are about to set up an auto top-up of your Impact Tokens.</p>

              <p v-if="(companySettings && companySettings.unallocated <= topupamt) || companySettings.length == 0">You will be charged <b>US ${{tokenamt|currency}} today</b> and <br>billed again <b>when your Token balance falls below US ${{topupamt|currency}}</b>.</p>

              <p v-else>You will be charged <b>US ${{tokenamt|currency}}</b> <br><b>when your Token balance falls below US ${{topupamt|currency}}</b>.</p>
            </span>
            <div class="text-center bee-img"><img src="/static/uploads/bee.png" alt="bee.png"></div>
            <div class="btn-sec"><button class="b-btn gray-btn" @click="setBackStep(2)" style="">BACK</button><button class="b-btn red-btn" @click="purchaseToken()" :disabled="startPurchase">PROCEED</button></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tokenAPI from '../../../api/token'
import userAPI from '../../../api/user'
import config from '../../../config/app'
import NotificationMixin from '../../../helper/mixin/Notification'
import store from '../../../store'

export default {
  props: {
    companySettings: {
      required: true
    },
    tokenDetails: {
      required: true
    },
    redirectPage: {
      required: true
    },
    engagementKey: {
      type: String,
      default: ''
    }
  },
  mixins: [NotificationMixin],
  data () {
    return {
      step: 1,
      optionLoader: true,
      billing_period: 'one-time',
      monthly_billing_period: 'beginning',
      isCharityCountry: false,
      charityCountry: config.charity_disclosure_countries,
      topupamt: 5,
      tokenamt: 50,
      minTokenPurchaseAmt: 50,
      surcharge: 0,
      onlyEditSettings: false,
      isUserCardAdded: false,
      startPurchase: false,
      url: '',
      givingCards: [],
      add_card_payment_server: config.host === 'https://account.b1g1.com' ? config.payment_server + '/payment-method-add' : config.payment_server + '/stage-payment-method-add',
      userToken: null,
      user: (store.getters.currentUser) ? store.getters.currentUser : null
    }
  },
  created () {
    // get token topup amount
    this.tokenamt = (this.user && this.user.register_source === 'trial-online') ? 5 : 50
    this.minTokenPurchaseAmt = this.tokenamt // diff amount for trial user and other users
    if (this.user !== null) {
      if (this.user.account === 'company' && this.user.companydata && this.charityCountry.includes(this.user.companydata.country_name)) {
        this.isCharityCountry = true
      } else if (this.user.user_business && this.charityCountry.includes(this.user.user_business.country_name)) {
        this.isCharityCountry = true
      } else {
        this.isCharityCountry = false
      }
    }
    // company surcharge
    if (this.tokenDetails && this.tokenDetails.surcharge) {
      this.surcharge = this.tokenDetails.surcharge
    }
    if (this.companySettings) {
      this.companySettings.unallocated = parseFloat(this.companySettings.unallocated)
      if ((this.companySettings.monthly_amount && this.companySettings.monthly_amount > 0 && this.companySettings.monthly_topup_setting === 'active') || (this.companySettings.auto_topup_amount && this.companySettings.auto_topup_amount > 0 && this.companySettings.auto_topup_setting === 'active')) {
        this.onlyEditSettings = true
      }
    }
    let userCardPromise = this.getUserCards()
    let userEncryptionIdPromise = userAPI.getUserEncryptedId().then((response) => {
      this.userToken = response
    })
    Promise.all([userCardPromise, userEncryptionIdPromise]).then(() => {
    })
  },
  methods: {
    checkNumbersOnly (strEleId) {
      // To check only numbers allowed
      let getEleId = strEleId
      var textInput = document.getElementById(getEleId).value
      textInput = textInput.replace(/[^0-9]/g, '')
      document.getElementById(getEleId).value = textInput
    },
    commafy (num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    showConfirmationModal () {
      if (this.tokenamt < this.minTokenPurchaseAmt || this.tokenamt > 5000) {
        if (this.tokenamt > 5000) {
          this.bToast('error', 'For a top-up amount above $5,000, we recommend a bank transfer. Please contact the B1G1 Team.')
        } else if ((this.tokenamt < this.minTokenPurchaseAmt)) {
          this.bToast('error', `Token amount should be at least US $${this.minTokenPurchaseAmt}.`)
        }
      } else if (this.billing_period === 'topup' && this.topupamt < 5) {
        this.bToast('error', 'Top-up amount should be at least US $5.')
      } else {
        this.step = 2
      }
    },
    setBackStep (previousStep) {
      this.step = previousStep - 1
    },
    close () {
      this.$emit('close')
    },
    getUserCards () {
      userAPI.getUserCardsListById().then((response) => {
        if (response.status) {
          this.givingCards = response.givingCards
          this.isUserCardAdded = response.givingCards.length > 0
          this.optionLoader = false
        }
      })
    },
    purchaseToken () {
      this.startPurchase = true
      let tokenData = {
        'tokenamount': this.tokenamt,
        'purchase_type': this.billing_period,
        'billing_cycle': this.monthly_billing_period,
        'auto_topup_amount': this.topupamt
      }
      tokenAPI.purchaseToken(tokenData).then((response) => {
        console.log('Purchase response', response)
        if (response.status === 'success') {
          console.log('token response - ', response.user_key, response.token_detail_id)
          if (this.billing_period === 'one-time') {
            if (this.engagementKey !== '') {
              window.location.href = config.host + '/payment-redirect/' + this.redirectPage + '/' + response.user_key + '/' + response.token_detail_id + '?engagement_key=' + this.engagementKey
            } else {
              window.location.href = config.host + '/payment-redirect/' + this.redirectPage + '/' + response.user_key + '/' + response.token_detail_id
            }
            this.startPurchase = false
          } else {
            this.bToast('success', response.msg)
            setTimeout(() => {
              this.$router.go()
            }, 2000)
          }
        } else {
          this.startPurchase = false
          this.bToast('error', response.msg)
        }
      })
    }
  }
}
</script>

<style lang="css" scoped>
.modal {
  background-color: rgba(0, 0, 0, 0.7);
}
#Token-popup .modal-content{
  min-height: 300px;
}
#Token-popup {
   display: flex !important;
   align-items: center;
   justify-content: center;
}
#Token-popup .modal-content {
  max-width: 760px;
  border-radius: 5px;
  margin:auto;
}
#Token-popup h2 {
  text-transform: uppercase !important;
  letter-spacing: 0;
  font-size: 20px;
  font-family: "Brandon Grotesque";
  margin-bottom: 20px;
  color:#000;
}
#token-amount, #topup-token-amount {
  border-radius: 5px;
  border: 1px solid #000;
  height: 33px;
  padding: 0px 8px;
}
#Token-popup .sub-options {
  padding-left: 25px;
}
#Token-popup button.red-btn {
  margin-bottom: 0px;
  width: 230px;
  border-radius: 5px !important;
}
#Token-popup button:disabled {
  opacity: 0.6;
  cursor: wait;
}
.billing-popup, .purchase-popup, .card-popup {
  padding: 20px;
}
.billing-popup p{text-align:center;}
#Token-popup .btn-sec {
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 60px;
}
#Token-popup button.gray-btn {
  width: 230px;
  height: 35px;
  border-radius: 5px !important;
  background: #979797;
}
#Token-popup button.gray-btn:hover{
  background: #575757;
}
.text-center.bee-img img {
  width: 60px;
}
.text-center.no-card-img img {
  width: 60px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.text-center.bee-img {
  padding: 20px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/business/token-popup-modal/purchase.vue